import React from 'react';

export const EMPLOYEE_POSITIONS = [
  'Security Guard',
  'Agent',
  'HR Department',
  'Software Department',
  'Team Leader',
  'Senior Team Leader',
  'IT Department',
  'Interim Team Leader',
  'Frontline Customer Service Representative',
  'Customer Service Representative',
  'Operations',
  'Intern',
];

export function PositionOptions({ includeEmpty = false, emptyLabel = '-- Select Position --', currentValue = null }) {
  const positions = [...EMPLOYEE_POSITIONS];
  if (currentValue && !positions.includes(currentValue)) {
    positions.push(currentValue);
  }

  return (
    <>
      {includeEmpty && <option value="">{emptyLabel}</option>}
      {positions.map((position) => (
        <option key={position} value={position}>{position}</option>
      ))}
    </>
  );
}
